import "./style.scss";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import CloseSvg from "@/src/svg/CustomUtils/CloseSvg";
import ArrowSvg from "@/src/svg/autoCompile/ArrowSvg";

type Props = {
  title: string;
  onClose: () => void;
};

const CustomDiscount = ({ title, onClose }: Props) => {
  return (
    <div className="custom-discount">
      <div className="custom-discount-title">
        <div className="custom-discount-title-text">
          <p>{title}</p>
        </div>
        <div className="custom-discount-title-close" onClick={onClose}>
          <CloseSvg />
        </div>
      </div>
      <div className="custom-discount-body">
        <div className="custom-discount-body-field">
          <div className="custom-discount-body-field-title">
            <p>Discount</p>
          </div>
          <div className="custom-discount-body-field-input">
            <input type="text" placeholder="0.00" />
            <p>USD</p>
          </div>
        </div>
        <div className="custom-discount-body-note">
          <textarea placeholder="Note..." />
        </div>
      </div>
      <div className="custom-discount-buttons">
        <BtnDefault>
          <p>Clear</p>
        </BtnDefault>
        <BtnDefault>
          <p>Done</p>
        </BtnDefault>
      </div>
      <div className="custom-discount-history">
        <div className="custom-discount-history-header">
          <p>History</p>
          <ArrowSvg />
        </div>
        <div className="custom-discount-history-list">
          <div className="custom-discount-history-list-item">
            <p>17.05.2025</p>
            <p>-1 480.00 USD</p>
          </div>
          <div className="custom-discount-history-list-item">
            <p>11.02.2025</p>
            <p>-1 180.00 USD</p>
          </div>
          <div className="custom-discount-history-list-item">
            <p>07.01.2025</p>
            <p>-420.00 USD</p>
          </div>
        </div>
        <div className="custom-discount-history-total">
          <p>Total</p>
          <p>-3 080.00 USD</p>
        </div>
      </div>
    </div>
  );
};

export default CustomDiscount;
